export const LIST_REWARD_USER = 'LIST_REWARD_USER'
export const REMOVE_REWARD_USER = 'REMOVE_REWARD_USER'
export const DETAIL_REWARD_USER = 'DETAIL_REWARD_USER'
